import React from 'react';
import PropTypes from 'prop-types';
import { VaAlertSignIn } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { VerifyButton } from 'platform/user/authentication/components/VerifyButton';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';

/**
 * Alert to show a user that has mhv basic account (is not verified).
 * @property {string} headerLevel optional heading level
 * @property {string} serviceDescription optional description of the service that requires verification
 */
const SignInOtherAccount = ({ headerLevel }) => {
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const clearSigninEnabled = useToggleValue(TOGGLE_NAMES.clearSigninEnabled);

  return (
    <VaAlertSignIn variant="signInEither" visible headingLevel={headerLevel}>
      <span slot="IdMeSignInButton">
        <VerifyButton csp="idme" />
      </span>
      <span slot="LoginGovSignInButton">
        <VerifyButton csp="logingov" />
      </span>
      {clearSigninEnabled && (
        <span slot="ClearSignInButton">
          <VerifyButton csp="clear" />
        </span>
      )}
    </VaAlertSignIn>
  );
};

SignInOtherAccount.propTypes = {
  headerLevel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  serviceDescription: PropTypes.string,
};

export default SignInOtherAccount;
